var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('embed',{attrs:{"src":_vm.src,"type":_vm.embedType,"id":_vm.type == 'pdf' ? 'embed-pdf' : ''}})])}
var staticRenderFns = []

export { render, staticRenderFns }